import React from 'react';
import { useSearchkit } from '@searchkit/client';
import Button from '../../../../Button';
var NumericRangeFilter = function NumericRangeFilter(_ref) {
  var filter = _ref.filter,
    loading = _ref.loading;
  var api = useSearchkit();
  return /*#__PURE__*/React.createElement(Button, {
    disabled: loading,
    onClick: function onClick() {
      api.removeFilter(filter);
      api.search();
    }
  }, filter.label, ": ", filter.min, " - ", filter.max);
};
export default NumericRangeFilter;